module.exports = __webpack_public_path__ + "img/fi-rr-umbrella.c5cf9ab5.svg";